/**
 * useClickOutsideListener
 * @param {boolean} active - state of component
 * @param {function} action - the action to perform on key press
 */

import { useEffect } from "react";

const useClickOutsideListener = (
  active: boolean,
  action: () => void,
  listenOnElement?: string
) => {
  useEffect(() => {
    const listener =
      listenOnElement && document.getElementById(listenOnElement)
        ? document.getElementById(listenOnElement)
        : document;
    if (typeof window !== "undefined") {
      listener.addEventListener("click", action, {
        once: true,
        capture: false,
      });
    }
    return () => listener.removeEventListener("click", action);
  }, [active]);
};
 
 export default useClickOutsideListener;
 